import { Observable } from "./Observable"

export function isObservable<T = any>(input: any): input is Observable<T> {
  return (
    input &&
    typeof input === "object" &&
    typeof input[Symbol.observable] === "function"
  )
}
